export default [
  {
    name: '1.1.1.1',
    url: 'https://1.1.1.1',
    image: '1111.png',
    description: 'Add a little bit of extra privacy to your internet browsing.'
  },
  {
    name: 'Figma',
    url: 'https://figma.com/@brian',
    image: 'figma.jpg',
    description:
      'Figma is my design tool of choice. Features like Auto Layout v3 and Variants make it really fast to iterate and explore while designing interfaces.'
  },
  {
    name: 'Vercel',
    url: 'https://vercel.com',
    image: 'vercel.jpg',
    description:
      'Everything I make on the internet lives on Vercel. Vercel is the gold standard of developer tools.'
  },
  {
    name: 'GitHub Mobile',
    url: 'https://github.com/mobile',
    image: 'github.png',
    description: 'First choice and best Version Control System.'
  },
  {
    name: 'Postmark',
    url: 'https://postmarkapp.com',
    image: 'postmark.png',
    independent: true,
    description: 'A simple, but powerful, tool for sending transactional emails.'
  },
  {
    name: 'Next.js',
    url: 'https://nextjs.org',
    image: 'nextjs.png',
    oss: true,
    description: 'The best way to build modern React websites.'
  },
  {
    name: 'Tailwind CSS',
    url: 'https://tailwindcss.com',
    image: 'tailwind.png',
    independent: true,
    oss: true,
    description:
      'A compositional CSS framework that makes styling websites easy. It’s like writing CSS on steroids.'
  },
  {
    name: 'Feather Icons',
    url: 'https://feathericons.com',
    image: 'feathericons.jpg',
    independent: true,
    oss: true,
    description:
      'A gorgeous open source icon set – easily grab SVGs, or integrate it directly into your React project.'
  }
]
